"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScript = void 0;
const react_1 = require("react");
const get_script_node_1 = require("./get-script-node");
const create_script_node_1 = require("./create-script-node");
const cachedScriptStatuses = new Map();
const useScript = (src, options) => {
    const { shouldPreventLoad, removeOnUnmount, id } = options || {};
    const isLoadAvailable = !!src && !shouldPreventLoad;
    const [status, setStatus] = (0, react_1.useState)(() => {
        if (!isLoadAvailable) {
            return 'idle';
        }
        return cachedScriptStatuses.get(src) ?? 'loading';
    });
    (0, react_1.useEffect)(() => {
        if (!isLoadAvailable) {
            return;
        }
        const cachedScriptStatus = cachedScriptStatuses.get(src);
        if (cachedScriptStatus === 'ready' || cachedScriptStatus === 'error') {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = (0, get_script_node_1.getScriptNode)(src);
        let scriptNode = script.node;
        if (scriptNode) {
            setStatus(script.status ?? cachedScriptStatus ?? 'loading');
        }
        else {
            scriptNode = (0, create_script_node_1.createScriptNode)(src, id);
            setStatus('loading');
        }
        const setStateFromEvent = (event) => {
            const newStatus = event.type === 'load' ? 'ready' : 'error';
            setStatus(newStatus);
            cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener('load', setStateFromEvent);
        scriptNode.addEventListener('error', setStateFromEvent);
        return () => {
            if (scriptNode) {
                scriptNode.removeEventListener('load', setStateFromEvent);
                scriptNode.removeEventListener('error', setStateFromEvent);
            }
            if (scriptNode && removeOnUnmount) {
                scriptNode.remove();
                cachedScriptStatuses.delete(src);
            }
        };
    }, [src, shouldPreventLoad, removeOnUnmount, id]);
    return status;
};
exports.useScript = useScript;
